module.exports = __webpack_public_path__ + "img/item4.11224ae5.png";